<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5l-8.66-5v-10l8.66-5l8.66,5v10L0.5,802.5L0.5,802.5z M0.5,801.61l7.89-4.56v-9.11l-7.89-4.56l-7.89,4.56v9.11
	L0.5,801.61L0.5,801.61z M0.5,800.29l-6.75-3.9v-7.79l6.75-3.9l6.75,3.9v7.79L0.5,800.29L0.5,800.29z M0.5,799.41l5.98-3.45v-6.91
	l-5.98-3.45l-5.98,3.45v6.91L0.5,799.41z M0.5,798.09l-4.84-2.79v-5.59l4.84-2.79l4.84,2.79v5.59L0.5,798.09L0.5,798.09z M0.5,797.2
	l4.07-2.35v-4.7L0.5,787.8l-4.07,2.35v4.7L0.5,797.2L0.5,797.2z M0.5,795.88l-2.93-1.69v-3.38l2.93-1.69l2.93,1.69v3.38L0.5,795.88
	L0.5,795.88z M0.5,795l2.16-1.25v-2.5L0.5,790l-2.16,1.25v2.5L0.5,795z M0.5,793.68l-1.02-0.59v-1.18l1.02-0.59l1.02,0.59v1.18
	L0.5,793.68z"/>
</svg>

</template>